/*  Shared  */
import { Response } from 'application/Shared/Helpers';
import Requests from 'application/Shared/Requests/Handler';
import { debug } from 'application/Shared/Utils';

/*  NPM  */
import axios from 'axios';

/*  Constants  */
const { hasData, getOne } = Response;

class Token {
    constructor() {
        this.requests = new Requests();
    }

    cancel = () => {
        this.requests.cancel();
    };

    getToken = async (params) => {
        try {
            const response = await axios.get('/tenantToken', {
                cancelToken: this.requests.token(),
                params
            });
            if (!hasData(response)) {
                debug.e('No Token Found', response);
                return false;
            }

            const tokenRecord = getOne(response);
            return tokenRecord.token;
        } catch (e) {
            debug.e('Unable to get Token', e);
            return false;
        }
    };
}

export default Token;
